import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import PageLoader from "../../../../../../components/PageLoader";
import storePersist from "../../../../../../redux/storePersist";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import { plans } from "../../../../../../redux/plans/action";
import { selectPlansListItems } from "../../../../../../redux/plans/selector";

const Agencyplans = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const PlansItems = useSelector(selectPlansListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const tenantItems = storePersist?.get("accessTokenMetadata")?.current?.TokenMetadata;
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      {
        field: 'Name', headerName: 'Name', searchField: 'Name', filter: true,
        filterType: 'text'
      },
      { field: 'IsActive', headerName: 'Active', cellRenderer: 'yesNoRenderer' },
      { field: 'StartDateUtc', headerName: 'Start Date', },
      { field: 'EndDateUtc', headerName: 'End Date', },

    ]);
  }

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(plans.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/marketing/campaign-plans/list`,
      entity: 'programHubs', jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }))
  }

  const handleReloadData = () => {
    dispatch(plans.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/marketing/campaign-plans/list`,
      entity: 'programHubs',
      jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }
  const filterTypes = [{
    name: 'Text', value: "text"
  },
  {
    name: 'Number', value: "number"
  },
  {
    name: 'CheckBox', value: "checkbox"
  },
  {
    name: 'Date', value: "date"
  }
  ]
  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }

  const fetchPrograms = () => {
    dispatch(plans.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/marketing/campaign-plans/list`,
      entity: 'plans',
      jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }
  const handleAdd = () => {
    navigate(`${0}`);
  };

  const additionButtons: any = [

    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Plans Topics</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,

      callback: () => handleReloadData(),
    },
  ];

  useEffect(() => {
    createColumnDefs()
    fetchPrograms()
  }, [pageData, pageSize])

  const handleDelete = (data: any) => {
    dispatch(plans.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/marketing/campaign-plans/delete`,
      entity: 'plans',
      jsonData: {

        "Context": {},
        "Records": [
          {
            "Message": {
              "Id": data?.Id
            }
          }
        ]


      }
    })).then(() => {
      fetchPrograms();
    });
  }

  return (
    <>
      {PlansItems?.isLoading ? <PageLoader /> :
        <Table
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }} enableFilter={true}
          filterTypeLists={filterTypes}
          onSearch={handleSearch} columnData={columnDefs}
          rowData={PlansItems?.result?.items} setPageData={setPageData}
          setPageSize={setPageSize} paginationData={PlansItems?.result?.pagination}
          onEdit={handleEdit} additionButtons={additionButtons}
          onDelete={handleDelete} headingName="Plans List"
        />
      }
    </>
  );
};

export default Agencyplans;